import React from 'react';

interface FormActionsProps {
  isEditing: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const FormActions: React.FC<FormActionsProps> = ({
  isEditing,
  isSubmitting,
  onCancel,
}) => {
  return (
    <div className="flex justify-end space-x-3 pt-4 border-t border-tinta/10">
      <button
        type="button"
        onClick={onCancel}
        className="px-4 py-2 border border-tinta/15 rounded-lg text-sm font-semibold text-tinta-soft hover:bg-creme-light hover:text-tinta focus:outline-none focus:ring-2 focus:ring-bordo/30 transition-colors"
        disabled={isSubmitting}
      >
        Cancelar
      </button>
      <button
        type="submit"
        disabled={isSubmitting}
        className="px-5 py-2 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark focus:outline-none focus:ring-2 focus:ring-bordo/40 disabled:opacity-50 transition-colors"
      >
        {isSubmitting ? 'Salvando...' : (isEditing ? 'Salvar' : 'Criar')}
      </button>
    </div>
  );
};

export default FormActions;
